import styled, { css } from "styled-components"

export const MainContainer = styled.div`
  width: ${props => (props.visibilityLegend && !props.isMobile ? "75%" : "100%")};
  height: ${props => (props.withChoicePath ? "calc(100% - 30px)" : "100%")};

  position: relative;
  margin: 0 0;

  #tooltip_container {
    .tooltip_header {
      border-top-right-radius: 5px;
      justify-content: flex-start;
      border-top-left-radius: 5px;
      align-items: center;
      padding: 0 0 0 20px;
      position: relative;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      height: 50px;
      width: 100%;

      .icon {
        align-items: center;
        position: absolute;
        font-size: 1rem;
        cursor: pointer;
        display: flex;
        height: 50px;
        width: 30px;
        right: 0;
        top: 0;
      }
    }

    .tooltip_body {
      padding: 20px;

      .value_container {
        .libelle {
          font-weight: bold;
          font-size: 1.25rem;
          color: #36a7cc;
        }

        .value {
          font-weight: bold;
          font-size: 1.5rem;
          color: #828282;
          margin: 0.5rem 1rem;
        }
      }
    }

    .tooltip_bodyPRNSN {
      padding: 20px;

      .label_LDP {
        color: #006e89;
        font-weight: bold;
        font-size: 0.9rem;
      }

      .value_LDP {
        font-size: 1rem;
        margin: 0.2rem 0 0.2rem 20px;
      }

      .libelle_pratique {
        color: #afca11;
        font-weight: bold;
        font-size: 1.25rem;
        margin: 0 0 0.5rem 0;
      }

      .sub_libelle_pratique {
        color: #8e8e8e;
        margin: 0 0 0 1rem;
        display: flex;

        .label {
          font-size: 0.9rem;
          margin: 0.1rem 0.5rem 0 0;
        }

        .value_pratique {
          font-size: 1.25rem;
          margin: 0 0 0.25rem 0;
        }
      }

      .sub_libelle_pratique_federation {
        color: #8e8e8e;
        margin: 0 0 0 1rem;

        .label {
          font-size: 0.9rem;
          margin: 0 0 0.5rem 0;
        }

        .value_pratique {
          font-size: 1.25rem;
          margin: 0 0 0.25rem 0;
        }
      }

      .value_sexe {
        display: flex;
        margin: 0 0 10px 15px;

        .licences_women_container {
          font-size: 1.25rem;
          color: #af2c8c;
          display: flex;
          align-items: center;

          i {
            font-size: 1.5rem;
          }

          .sexe_value {
            margin: 0 0 0 5px;
          }

          span {
            font-size: 1rem;
            margin: 7px 0 0 0;
          }
        }

        .licences_men_container {
          font-size: 1.25rem;
          color: #afca11;
          display: flex;
          margin: 0 10px 0 0;
          align-items: center;

          i {
            font-size: 1.5rem;
          }

          .sexe_value {
            margin: 0 0 0 5px;
          }

          span {
            font-size: 1rem;
            margin: 7px 0 0 0;
          }
        }
      }

      .value_container {
        .value_sexe {
          display: flex;
          margin: 0 0 10px 15px;

          .women_container {
            font-weight: bold;
            color: #9185bb;
            display: flex;

            i {
              font-size: 1.5rem;
            }

            .sexe_value {
              font-size: 1.5rem;
              margin: 0 0 0 5px;
            }

            span {
              font-size: 1rem;
              margin: 7px 0 0 0;
            }
          }

          .men_container {
            font-size: 1.5rem;
            font-weight: bold;
            color: #026f88;
            display: flex;
            margin: 0 10px 0 0;

            i {
              font-size: 1.5rem;
            }

            .sexe_value {
              margin: 0 0 0 5px;
            }

            span {
              font-size: 1rem;
              margin: 7px 0 0 0;
            }
          }
        }

        .libelle {
          font-weight: bold;
          font-size: 1.25rem;
          color: #4193a6;
        }

        .value {
          font-weight: bold;
          font-size: 1.5rem;
          color: #828282;
          margin: 0.5rem 1rem;
        }

        .value_with_label {
          font-weight: bold;
          font-size: 1.5rem;
          color: #828282;
          margin: 0.5rem 1rem;
          display: flex;

          span {
            font-size: 0.9rem;
            margin: 9px 0 0 5px;
          }
        }
      }

      .button_tooltip_PRNSN {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 20px;
        background-color: transparent;
        color: #4193a6;
        border: 1px solid #4193a6;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.2s ease 0s;
      }
    }
  }

  #choice_path_container {
    justify-content: center;
    border-radius: 5px;
    margin: 0 0 2rem 0;
    display: flex;
    height: 30px;
    width: 100%;

    .button {
      justify-content: center;
      align-items: center;
      color: #787878;
      cursor: pointer;
      display: flex;
      height: 30px;
      width: 150px;
    }

    .isActive {
      color: #787878;
      justify-content: center;
      align-items: center;
      display: flex;
      height: 30px;
      width: 150px;
    }
  }

  #button_zoom_container {
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
    position: absolute;
    border-radius: 5px;
    height: 70px;
    width: 30px;
    top: 10px;
    right: 10px;

    .button {
      background-color: #fff;
      justify-content: center;
      align-items: center;
      color: #828282;
      cursor: pointer;
      font-size: 0.7rem;
      display: flex;
      height: 34px;
      width: 30px;
    }

    .liseret {
      background-color: #cacaca;
      margin: 0 2.5px;
      height: 2px;
      width: 25px;
    }
  }

  #map_SVG_container {
    z-index: 2;

    .map_item_svg {
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .clear_filter_button {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`

export const LegendContainer = styled.div`
  position: absolute;
  top: 50%;
  right: -300px;
  height: 125px;
  width: 300px;
  z-index: 1;

  .main_label {
    align-items: center;
    padding: 0 0 0 10px;
    display: flex;
    height: 50px;
    width: 100%;
  }

  .legend {
    padding: 0 0 0 10px;
    width: 100%;

    .legend_item {
      align-items: center;
      color: #4d5860;
      font-size: 0.8rem;
      display: flex;
      height: 25px;
    }
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin: 0 0 0 25%;
      height: fit-content;
      position: relative;
      width: 100%;
      right: 0;
    `}
`

export const Legend = styled.div`
  margin: 0 10px 0 0;
  border-radius: 5px;
  height: 20px;
  width: 25px;
  background-color: ${props => (props.bckgColor ? props.bckgColor : "")};
`

export const RoundLegend = styled.svg`
  margin: 0 10px 0 0;
`

export const MainLabel = styled.div`
  color: ${props => (props.labelColor ? props.labelColor : "#4d5860")};
  font-size: ${props => (props.labelSize ? props.labelSize : "1rem")};
  font-weight: ${props => (props.labelWeight ? props.labelWeight : "bold")};
`
